export const environment = {
  production: true,
  buildId: '3200997700020891',
  configFile: 'config.json',
};
